import { types } from "../constants/types";

const initialState = {

    getPaymentSetting : [],
    getPaymentSettingFailed : '',

    getAllPaymentSetting : [],
    getAllPaymentSettingFailed : '',

    updatePaymentSetting : [],
    updatePaymentSettingFailed : '',

}

//receives the current state and an action object
export function settingReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_PAYMENT_SETTING_SUCCESS:
            return {
                ...state,
                getPaymentSetting : action.payload
            }
        case types.GET_PAYMENT_SETTING_FAILED:
            return {
                ...state,
                getPaymentSettingFailed : action.payload
            }
        case types.GET_ALL_PAYMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                getAllPaymentSetting : action.payload
            }
        case types.GET_ALL_PAYMENT_SETTINGS_FAILED:
            return {
                ...state,
                getAllPaymentSettingFailed : action.payload
            }    
        case types.UPDATE_PAYMENT_SETTING_SUCCESS:
            return {
                ...state,
                updatePaymentSetting : action.payload
            }
        case types.UPDATE_PAYMENT_SETTING_FAILED:
            return {
                ...state,
                updatePaymentSettingFailed : action.payload
            }
        
        default:
            return state
    }
}